import { sbFromEnv } from '../lib/supabase';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL!;
const supabaseAnon = import.meta.env.VITE_SUPABASE_ANON_KEY!;

// A lightweight client only for session lookups; UI elsewhere uses your hydrated client.
const supabase = sbFromEnv({
  url: supabaseUrl,
  key: supabaseAnon,
});

export async function jsonFetch<T = unknown>(
  input: string,
  init: RequestInit = {},
): Promise<T> {
  // get fresh session token
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;

  const headers = new Headers(init.headers || {});
  headers.set('content-type', 'application/json; charset=utf-8');
  if (token) headers.set('authorization', `Bearer ${token}`);

  const res = await fetch(input, { ...init, headers });

  // Normalize errors for caller
  const text = await res.text();
  let body: any = null;
  try {
    body = text ? JSON.parse(text) : null;
  } catch {
    body = text;
  }

  if (!res.ok) {
    const raw = body?.error;
    const msg = typeof raw === 'string'
      ? raw
      : raw?.message ?? raw?.msg ?? `HTTP ${res.status}`;
    throw new Error(msg);
  }
  return body as T;
}
